import { BrandBar } from '../components/index.js';
import { LegalFooter } from '../components/LegalFooter.js';
import { OFFERING } from '@shared/config.js';

/**
 * Shown straight after the form, while the Scorecard is held back pending
 * double opt-in.
 *
 * The score itself was already given away on screen 3 and is not retracted —
 * what waits on confirmation is the Scorecard and the category detail. The copy
 * says exactly what happens next and how long the link lasts, because the most
 * common failure here is a visitor who simply does not realise they must act.
 */
export default function ConfirmEmail({
  email,
  expiresInHours,
  onResend,
  resending,
  resent,
}: {
  email: string;
  expiresInHours: number;
  onResend: () => void;
  resending: boolean;
  resent: boolean;
}) {
  return (
    <div className="app">
      <BrandBar tag={`Confirm your email`} />

      <main className="screen screen--scroll screen--center">
        <div className="confirm-wrap">
          <div className="confirm-mark" aria-hidden="true" />
          <h1 className="confirm-h">Check your inbox</h1>
          <p className="confirm-lede">
            We've sent a confirmation link to <b>{email}</b>. Click it and your{' '}
            {OFFERING.deliverable} opens straight away, along with the full eight-category
            breakdown.
          </p>

          <ul className="confirm-list">
            <li>
              <b>Check your spam folder.</b> The link often lands there — mark it as not spam and
              it will open normally.
            </li>
            <li>The link works once and expires in {expiresInHours / 24} days.</li>
            <li>Nothing else is sent to you — this is not a subscription.</li>
          </ul>

          {/* Without this a filtered mail is a dead end: the visitor cannot
              re-submit either, because the address is already on file. */}
          <div className="confirm-resend">
            {resent ? (
              <p className="confirm-resend-done">
                Sent again to <b>{email}</b>. Give it a minute, and check spam.
              </p>
            ) : (
              <>
                <span>Still nothing?</span>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onResend}
                  disabled={resending}
                >
                  {resending ? 'Sending…' : 'Send the link again'}
                </button>
              </>
            )}
            <p className="confirm-resend-alt">
              Or write to <a href={`mailto:${OFFERING.contactEmail}`}>{OFFERING.contactEmail}</a>{' '}
              and we will send the Scorecard directly.
            </p>
          </div>

        </div>
      </main>

      <LegalFooter />
    </div>
  );
}
